import type { ReportFilter } from '../models/filter.types'
import type { ReportCardStatus } from '../models/tablePresentation.types'

export function cardStatusFilters(status: ReportCardStatus): ReportFilter[] {
  if (status === 'active') return [{ field: 'stop_time', match_mode: 'not_regex', value: '.*2' }]
  if (status === 'disabled') return [{ field: 'stop_time', match_mode: 'regex', value: '.*2' }]
  return []
}
